module.exports = __webpack_public_path__ + "static/media/arrowDown.11fd2d17.svg";